// extracted by mini-css-extract-plugin
export var skillStatusIconLegend = "skills-module--skillStatusIconLegend--qMj1-";